// src/search-definitions/planoSearch.js

export const configBuscaPlano = {
  label: 'Plano',
  placeholder: 'ID ou Nome...',
  titulo: 'Buscar Plano de Contratação',
  endpointApi: 'Planos',
  idField: 'idPlano',
  displayField: 'idPlano',
  descField: 'nome',

  camposFiltro: [
    { label: 'Nome do Plano', model: 'nome', tipo: 'text' },
    { label: 'Descrição', model: 'descricao', tipo: 'text' },
    { label: 'Validade Início', model: 'validadeInicio', tipo: 'date' },
    { label: 'Validade Fim', model: 'validadeFim', tipo: 'date' }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idPlano', width: '15%' },
    { header: 'Nome', dataField: 'nome', width: '35%' },
    { header: 'Descrição', dataField: 'descricao', width: '50%' }
  ]
}
